var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 16.16C25.9401 16.15 25.8701 16.15 25.8101 16.16C24.4301 16.11 23.3301 14.98 23.3301 13.58C23.3301 12.15 24.4801 11 25.9101 11C27.3401 11 28.4901 12.16 28.4901 13.58C28.4801 14.98 27.3801 16.11 26.0001 16.16Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9699 23.4399C26.3399 23.6699 27.8499 23.4299 28.9099 22.7199C30.3199 21.7799 30.3199 20.2399 28.9099 19.2999C27.8399 18.5899 26.3099 18.3499 24.9399 18.5899",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 16.16C14.03 16.15 14.1 16.15 14.16 16.16C15.54 16.11 16.64 14.98 16.64 13.58C16.64 12.15 15.49 11 14.06 11C12.63 11 11.48 12.16 11.48 13.58C11.49 14.98 12.59 16.11 13.97 16.16Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 23.4399C13.6299 23.6699 12.1199 23.4299 11.0599 22.7199C9.64994 21.7799 9.64994 20.2399 11.0599 19.2999C12.1299 18.5899 13.6599 18.3499 15.0299 18.5899",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 23.63C19.9401 23.62 19.8701 23.62 19.8101 23.63C18.4301 23.58 17.3301 22.45 17.3301 21.05C17.3301 19.62 18.4801 18.47 19.9101 18.47C21.3401 18.47 22.4901 19.63 22.4901 21.05C22.4801 22.45 21.3801 23.59 20.0001 23.63Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0902 26.7799C15.6802 27.7199 15.6802 29.2599 17.0902 30.1999C18.6902 31.2699 21.3102 31.2699 22.9102 30.1999C24.3202 29.2599 24.3202 27.7199 22.9102 26.7799C21.3202 25.7199 18.6902 25.7199 17.0902 26.7799Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrew);
export default __webpack_public_path__ + "static/media/crew.42b0806a82695af9d9ee324d6897d7d9.svg";
export { ForwardRef as ReactComponent };